"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { CreateWaveOutcomeConfig, CreateWaveOutcomeConfigWinnersConfig } from "@/types/waves.types";
import { CreateWaveOutcomeConfigWinnersCreditValueType, CreateWaveOutcomeType } from "@/types/waves.types";
import RepCategorySearch from "@/components/utils/input/rep-category/RepCategorySearch";
import CreateWaveOutcomesWinners from "../winners/CreateWaveOutcomesWinners";
import PrimaryButton from "@/components/utils/button/PrimaryButton";
export default function CreateWaveOutcomesRepRank(t0) {
  const $ = _c(39);
  const {
    onOutcome,
    onCancel
  } = t0;
  const outcomeType = CreateWaveOutcomeType.REP;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      type: outcomeType,
      title: null,
      credit: null,
      category: null,
      winnersConfig: {
        creditValueType: CreateWaveOutcomeConfigWinnersCreditValueType.ABSOLUTE_VALUE,
        totalAmount: 0,
        winners: [{
          value: 0
        }]
      },
      maxWinners: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [outcome, setOutcome] = useState(t1);
  const [categoryError, setCategoryError] = useState(false);
  const [totalValueError, setTotalValueError] = useState(false);
  const [percentageError, setPercentageError] = useState(false);
  let t2;
  if ($[1] !== outcome) {
    t2 = category => {
      setCategoryError(false);
      setOutcome({
        ...outcome,
        category
      });
    };
    $[1] = outcome;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const setCategory = t2;
  let t3;
  if ($[3] !== outcome) {
    t3 = winnersConfig => {
      setTotalValueError(false);
      setPercentageError(false);
      setOutcome({
        ...outcome,
        maxWinners: winnersConfig.winners.length,
        winnersConfig
      });
    };
    $[3] = outcome;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const setWinnersConfig = t3;
  let t4;
  if ($[5] !== outcome.winnersConfig?.winners) {
    t4 = () => outcome.winnersConfig?.winners.reduce(_temp, 0) ?? null;
    $[5] = outcome.winnersConfig?.winners;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const getWinnersTotal = t4;
  let t5;
  if ($[7] !== getWinnersTotal || $[8] !== outcome.winnersConfig?.creditValueType || $[9] !== outcome.winnersConfig?.totalAmount) {
    t5 = () => {
      if (outcome.winnersConfig?.creditValueType === CreateWaveOutcomeConfigWinnersCreditValueType.ABSOLUTE_VALUE) {
        const totalValue = getWinnersTotal();
        if (!totalValue) {
          return true;
        }
        if (totalValue !== outcome.winnersConfig?.totalAmount) {
          return true;
        }
      } else {
        return !outcome.winnersConfig?.totalAmount;
      }
      return false;
    };
    $[7] = getWinnersTotal;
    $[8] = outcome.winnersConfig?.creditValueType;
    $[9] = outcome.winnersConfig?.totalAmount;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const getTotalValueError = t5;
  let t6;
  if ($[11] !== getWinnersTotal || $[12] !== outcome.winnersConfig?.creditValueType) {
    t6 = () => {
      if (outcome.winnersConfig?.creditValueType !== CreateWaveOutcomeConfigWinnersCreditValueType.PERCENTAGE) {
        return false;
      }
      return getWinnersTotal() !== 100;
    };
    $[11] = getWinnersTotal;
    $[12] = outcome.winnersConfig?.creditValueType;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const getPercentageError = t6;
  let t7;
  if ($[14] !== getPercentageError || $[15] !== getTotalValueError || $[16] !== onOutcome || $[17] !== outcome) {
    t7 = () => {
      const dontHaveCategorySet = !outcome.category;
      const totalValueError_0 = getTotalValueError();
      const percentageError_0 = getPercentageError();
      setCategoryError(dontHaveCategorySet);
      setTotalValueError(totalValueError_0);
      setPercentageError(percentageError_0);
      if (dontHaveCategorySet || totalValueError_0 || percentageError_0) {
        return;
      }
      onOutcome(outcome);
    };
    $[14] = getPercentageError;
    $[15] = getTotalValueError;
    $[16] = onOutcome;
    $[17] = outcome;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  const onSubmit = t7;
  let t8;
  if ($[19] !== categoryError || $[20] !== outcome.category || $[21] !== setCategory) {
    t8 = <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-5 tw-w-full tw-pt-[0.5px]"><RepCategorySearch error={categoryError} category={outcome.category} setCategory={setCategory} /></div>;
    $[19] = categoryError;
    $[20] = outcome.category;
    $[21] = setCategory;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== outcome.winnersConfig || $[24] !== percentageError || $[25] !== setWinnersConfig || $[26] !== totalValueError) {
    t9 = outcome.winnersConfig && <CreateWaveOutcomesWinners winnersConfig={outcome.winnersConfig} totalValueError={totalValueError} percentageError={percentageError} outcomeType={outcomeType} setWinnersConfig={setWinnersConfig} />;
    $[23] = outcome.winnersConfig;
    $[24] = percentageError;
    $[25] = setWinnersConfig;
    $[26] = totalValueError;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== onCancel) {
    t10 = <button onClick={onCancel} type="button" className="tw-bg-iron-800 tw-border-iron-700 tw-text-iron-300 hover:tw-bg-iron-700 hover:tw-border-iron-700 tw-relative tw-inline-flex tw-items-center tw-justify-center tw-px-4 tw-py-3 tw-text-sm tw-font-semibold tw-border tw-border-solid tw-rounded-lg tw-transition tw-duration-300 tw-ease-out">Cancel</button>;
    $[28] = onCancel;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== onSubmit) {
    t11 = <PrimaryButton onClicked={onSubmit} disabled={false} loading={false} padding="tw-px-4 tw-py-3">Save</PrimaryButton>;
    $[30] = onSubmit;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t10 || $[33] !== t11) {
    t12 = <div className="tw-flex tw-justify-end tw-gap-x-3">{t10}{t11}</div>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  let t13;
  if ($[35] !== t12 || $[36] !== t8 || $[37] !== t9) {
    t13 = <div className="tw-flex tw-flex-col tw-gap-y-5">{t8}{t9}{t12}</div>;
    $[35] = t12;
    $[36] = t8;
    $[37] = t9;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
}
function _temp(acc, winner) {
  return acc + winner.value;
}